import React from "react";

import Grid from "core/Grid";

import PhotosSectionCard from "./PhotosSectionCard";
import {
    PhotosPricingTableHeaderBasic,
    PhotosPricingTableHeaderLarge,
    PhotosPricingTableHeaderFullRes
} from "./photosPricingTableHeaders";

import { Table, TableHead, TableBody, TableRow } from "core/Table";
import {
    FeatureTableMobileColumnHeading,
    FeatureTableMobileBullet,
    FeatureTableMobileList
} from "core/FeatureTableMobile";

import {
    photosPricingBasicTable,
    photosPricingLargeTable,
    photosPricingFullResTable,
    photosPricingTableHeadingIds as headingIds
} from "./data";

const PhotosPricingTableMobile = () => (
    <Grid mobileSpacing={16} tabletSpacing={16} desktopSpacing={16}>
        <Grid item sm={12} md={6} lg={6}>
            <Table>
                <TableHead>
                    <TableRow>
                        <FeatureTableMobileColumnHeading
                            id={headingIds.basic}
                            scope="col"
                        >
                            <PhotosPricingTableHeaderBasic />
                        </FeatureTableMobileColumnHeading>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <FeatureTableMobileList height="15.125rem">
                        {photosPricingBasicTable.map(bullet => (
                            <FeatureTableMobileBullet
                                key={bullet[0]}
                                isFeature={bullet[1]}
                                headers={headingIds.basic}
                            >
                                {bullet[0]}
                            </FeatureTableMobileBullet>
                        ))}
                    </FeatureTableMobileList>
                </TableBody>
            </Table>
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
            <Table>
                <TableHead>
                    <TableRow>
                        <FeatureTableMobileColumnHeading
                            id={headingIds.large}
                            scope="col"
                        >
                            <PhotosPricingTableHeaderLarge />
                        </FeatureTableMobileColumnHeading>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <FeatureTableMobileList height="15.125rem">
                        {photosPricingLargeTable.map(bullet => (
                            <FeatureTableMobileBullet
                                key={bullet[0]}
                                isFeature={bullet[1]}
                                headers={headingIds.large}
                            >
                                {bullet[0]}
                            </FeatureTableMobileBullet>
                        ))}
                    </FeatureTableMobileList>
                </TableBody>
            </Table>
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
            <Table>
                <TableHead>
                    <TableRow>
                        <FeatureTableMobileColumnHeading
                            id={headingIds.fullRes}
                            scope="col"
                        >
                            <PhotosPricingTableHeaderFullRes />
                        </FeatureTableMobileColumnHeading>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <FeatureTableMobileList height="15.125rem">
                        {photosPricingFullResTable.map(bullet => (
                            <FeatureTableMobileBullet
                                key={bullet[0]}
                                isFeature={bullet[1]}
                                headers={headingIds.fullRes}
                            >
                                {bullet[0]}
                            </FeatureTableMobileBullet>
                        ))}
                    </FeatureTableMobileList>
                </TableBody>
            </Table>
        </Grid>
        <Grid item sm={12} md={6} lg={6}>
            <Grid desktopSpacing={0}>
                <Grid item sm={12} md={12} lg={6}>
                    <PhotosSectionCard />
                </Grid>
                <Grid item sm={12} md={12} lg={6}>
                    <PhotosSectionCard editorialUseOnly />
                </Grid>
            </Grid>
        </Grid>
    </Grid>
);

export default PhotosPricingTableMobile;
